module.exports = __webpack_public_path__ + "static/media/Christmas_2.4a70ccfd.jpg";